import React from "react";
import classNames from "@js/helpers/class_names.js";

const ScreenBody = function(props) {
  let style = {
    position: "fixed",
    top: 55,
    left: 0,
    right: 0,
    bottom: 55,
    zIndex: 10000,
    overflowY: "scroll",
  };

  if (props.style) {
    style = { ...style, ...props.style };
  }

  let classObject = {};
  if (props.className) {
    classObject[props.className] = true;
  }
  let calculatedClassname = classNames(classObject);

  return (
    <div
      id="react-content-editor-container"
      style={style}
      className={calculatedClassname}
    >
      {props.children}
    </div>
  );
};
export default ScreenBody;
